import React, { useContext, useState } from "react";
import Navbar from "../components/Navbar";
import Page from "../components/Page";
import { DatabaseContext } from "../contexts/filrebase";
import { useUser } from "../contexts/user";
import navigationMessages from "../i18n/navigation";
import "./NewRoom.css";
import Header from "../components/Header";

export function NewRoom({ history }) {
  const db = useContext(DatabaseContext);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [width, setWidth] = useState(1);
  const [height, setHeight] = useState(4);
  const { user } = useUser();

  const onSubmit = (e) => {
    e.preventDefault();
    const key = db.ref().child("rooms").push().key;

    const data = {
      name,
      description,
      width,
      height,
      uid: user.uid,
      createdAt: Date.now(),
    };

    db.ref()
      .update({
        [`/rooms/${key}`]: data,
      })
      .then(() => {
        history.push(`/rooms/${key}`);
      });
  };

  const disabled = !name || !+width || !+height;

  return (
    <Page className="NewRoom">
      <Navbar
        items={[
          { to: "/rooms", text: navigationMessages.roomList },
          { to: "/logout", text: navigationMessages.logout },
        ]}
      />
      <Header size="h1" paddingX={10}>
        Create New Room{" "}
        <span role="img" aria-label="new room icon">
          ✏️
        </span>
      </Header>
      <div style={{ paddingLeft: 10, paddingRight: 10, width: "100%" }}>
        <form onSubmit={onSubmit}>
          <label>
            <div>Name*:</div>
            <input
              required
              minLength={3}
              maxLength={64}
              value={name}
              name="name"
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label>
            <div>Description:</div>
            <input
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </label>
          <label>
            <div>Width*:</div>
            <input
              required
              name="width"
              type="number"
              min={1}
              max={32}
              value={width}
              // TODO: validate width & height are numbers in DB rules:
              //  ({height: {".validation": 'newData.isNumber()'}, width: {".validation": 'newData.isNumber()'}})
              onChange={(e) => setWidth(+e.target.value)}
            />
          </label>
          <label>
            <div>Height*:</div>
            <input
              required
              type="number"
              name="height"
              min={1}
              max={32}
              value={height}
              onChange={(e) => setHeight(+e.target.value)}
            />
          </label>
          <center>
            <button disabled={disabled} type="submit">
              <span role="img" aria-label="save">
                💾
              </span>
            </button>
          </center>
        </form>
      </div>
    </Page>
  );
}

export default NewRoom;
